export const CREATE_OR_UPDATE_BLOCK = 'CREATE_OR_UPDATE_BLOCK';
export const CREATE_OR_UPDATE_BLOCK_PROPERTIES = 'CREATE_OR_UPDATE_BLOCK_PROPERTIES';
export const CREATE_OR_UPDATE_CHILDREN_BLOCKS = 'CREATE_OR_UPDATE_CHILDREN_BLOCKS';
export const CREATE_OR_UPDATE_PRESENTATION_BLOCK = 'CREATE_OR_UPDATE_PRESENTATION_BLOCK';
export const CREATE_OR_UPDATE_PRESENTATION_CHILDREN_BLOCKS = 'CREATE_OR_UPDATE_PRESENTATION_CHILDREN_BLOCKS';
export const DELETE_BLOCK = 'DELETE_BLOCK';
export const DELETE_BLOCK_IN_DRAFTSTATUS = 'DELETE_BLOCK_IN_DRAFTSTATUS';
export const SET_DRAFTSTATUS = 'SET_DRAFTSTATUS';
export const UPDATE_BLOCK_IN_CHILDREN = 'UPDATE_BLOCK_IN_CHILDREN';